// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_c-2";
export var blackBorderOnHover = "_c-7";
export var cell = "_c-6";
export var cellContainer = "_c-3";
export var checked = "_c-8";
export var disabled = "_c-5";
export var featuredIconCellContainer = "_c-9";
export var featuredIconTextContainer = "_c-b";
export var featuredIconWrapper = "_c-a";
export var noBorder = "_c-c";
export var orangeSelectedRow = "_u-3";
export var overflowableText = "_c-0";
export var overflowableTextContainer = "_c-1";
export var row = "_f-0";
export var rowCheckboxCell = "_c-4";
export var selectableTable = "_u-2";